import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Discord Bot Developer",
          "Freelancer",
          "Telegram Bot Developer",
          "Open Source Contributor",
          "Crypto, Stocks, and AI Enthusiast",
          "FiveM Player",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
